import { render, staticRenderFns } from "./Respaldo.vue?vue&type=template&id=2150b612&"
import script from "./Respaldo.vue?vue&type=script&lang=js&"
export * from "./Respaldo.vue?vue&type=script&lang=js&"
import style0 from "./Respaldo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports